<template>
  <jumbotron>

    <div class="info-message">Password Reset</div>

    <div class="text-center my-5" v-show="loading">
      <i class="fas fa-sync-alt fa-spin fa-5x"/>
    </div>

    <div class="text-center mt-5" v-show="!validToken">
      <h4 class="text-danger">The token is not valid.</h4>
    </div>

    <div v-show="!loading && validToken">
      <p class="mt-3 font-weight-bold">Please Enter Your New Password</p>

      <user-password :user-id="$route.params.userId" @password-changed="pass => password = pass"
                      @valid-changed="valid => isValid = valid"/>

      <div class="text-right">
        <button class="btn btn-outline-primary ml-auto" :disabled="!isValid" @click="setPassword">
          <i class="fas fa-lock fa-fw"/>
          Set Password
        </button>
      </div>
    </div>

  </jumbotron>
</template>

<script>
import loginService from './login-service'
import UserPassword from '@/common/elements/user-password/UserPassword'
import alertsMixin from '@/common/mixins/alerts-mixin'
import jumbotron from '@/common/elements/Jumbotron'

export default {
  components: { UserPassword, jumbotron },
  name: 'resetPassword',
  mixins: [ alertsMixin ],
  data () {
    return {
      loading: true,
      validToken: true,
      isValid: false,
      password: ''
    }
  },
  mounted () {
    this.validateToken()
  },
  methods: {
    validateToken () {
      loginService.validateToken(this.$route.params.userId, this.$route.params.token)
        .then(valid => {
          this.validToken = valid
          this.loading = false
        })
    },
    setPassword () {
      this.loading = true

      loginService.setPassword(this.$route.params.userId, this.$route.params.token, this.password)
        .then(() => {
          this.alertSuccess('The password has been updated successfully.')
          this.$router.push({ name: 'login' }).catch(() => {})
        })
        .catch(() => {
          this.loading = false
          this.alertError('Unable to set password. Please try again later.')
        })
    }
  }
}
</script>

<style>
  .info-message {
    font-size: 2rem;
  }
</style>
